import React from 'react';
import { Link } from 'react-router-dom';
import { HandHeart, ArrowRight } from 'lucide-react';

export default function HopeFloatsSpotlight() {
  return (
    <section className="py-10" data-testid="home-hope-floats-spotlight">
      <div className="max-w-7xl mx-auto px-6">
        <Link
          to="/sponsor-a-lesson"
          data-testid="hope-floats-spotlight-link"
          className="group flex flex-col sm:flex-row sm:items-center gap-4 rounded-3xl border-2 border-dashed border-splash-coral/50 bg-white px-6 py-5 hover:border-splash-coral btn-transition"
        >
          <div className="shrink-0 w-12 h-12 rounded-full bg-splash-coral/15 text-splash-coralDark grid place-items-center">
            <HandHeart className="w-6 h-6" />
          </div>
          <div className="flex-1">
            <div className="text-[11px] uppercase tracking-widest text-splash-coral font-semibold">Community Spotlight &middot; Hope Floats Partner</div>
            <div className="font-display font-bold text-xl md:text-2xl text-splash-green">Sponsor a lesson for a Des Moines child.</div>
            <div className="text-sm text-splash-green/70">Every $40 funds one group class through the Hope Floats Foundation.</div>
          </div>
          <span className="inline-flex items-center gap-1 text-splash-coralDark font-semibold text-sm">
            Learn more <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </span>
        </Link>
      </div>
    </section>
  );
}
